import { render, staticRenderFns } from "./blockBack.vue?vue&type=template&id=31959a0e&"
import script from "./blockBack.vue?vue&type=script&lang=js&"
export * from "./blockBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports